export const GlobalConstant = {
  PHONE_BREAK_POINT: 768,
  DATA_BASE64_PREFIX: 'data:image/png;base64,',
};
